/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetMarketsGroupsMarketGroupIdNotFound
 */
export interface GetMarketsGroupsMarketGroupIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetMarketsGroupsMarketGroupIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetMarketsGroupsMarketGroupIdNotFound interface.
 */
export function instanceOfGetMarketsGroupsMarketGroupIdNotFound(value: object): value is GetMarketsGroupsMarketGroupIdNotFound {
    return true;
}

export function GetMarketsGroupsMarketGroupIdNotFoundFromJSON(json: any): GetMarketsGroupsMarketGroupIdNotFound {
    return GetMarketsGroupsMarketGroupIdNotFoundFromJSONTyped(json, false);
}

export function GetMarketsGroupsMarketGroupIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketsGroupsMarketGroupIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetMarketsGroupsMarketGroupIdNotFoundToJSON(json: any): GetMarketsGroupsMarketGroupIdNotFound {
    return GetMarketsGroupsMarketGroupIdNotFoundToJSONTyped(json, false);
}

export function GetMarketsGroupsMarketGroupIdNotFoundToJSONTyped(value?: GetMarketsGroupsMarketGroupIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

